module.exports = __webpack_public_path__ + "static/media/the-rig.ddae5454.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/the-rig.jpg
 ** module id = 438
 ** module chunks = 0
 **/